// extracted by mini-css-extract-plugin
export default {"root":"style_root__uNEcY","message":"style_message__HAx0o","pendingContainer":"style_pendingContainer__K3pQf","link":"style_link__T2DcJ"};